import { env } from '@/infra/config/env'

function getOidcStorageKey(): string {
  return `oidc.user:${env.KEYCLOAK_BASE_URL}/realms/${env.KEYCLOAK_REALM}:${env.KEYCLOAK_CLIENT_ID}`
}

export function getAuthToken(): string | null {
  try {
    const oidcStorage = sessionStorage.getItem(getOidcStorageKey())
    if (!oidcStorage) return null
    const userData = JSON.parse(oidcStorage) as { access_token?: string }
    return userData.access_token ?? null
  } catch {
    return null
  }
}
